import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAccountData } from '../redux/main/accountSlice';

/**
 * Component to dynamically update the page title based on the logged user's account.
 * Uses the commercialLabel property from the account data.
 */
const DynamicTitle = () => {
  const accountData = useSelector(selectAccountData);

  useEffect(() => {
    // Only update title when account data is available
    if (accountData && accountData.commercialLabel) {
      document.title = accountData.commercialLabel;
    } else {
      // Fallback to default title if no account data is available
      document.title = 'Aranet';
    }
  }, [accountData]);

  // This component doesn't render anything, it just updates the document title
  return null;
};

export default DynamicTitle;
